export default "__VITE_ASSET__ChQ3Fwr4__"